const navBarLabels = {
  "nav.bar.profile": "Perfil",
  "nav.bar.switch-profile": "Cambiar de perfil",
  "nav.bar.settings": "Configuración",
  "nav.bar.sign-out": "Cerrar sesión",
  "nav.bar.whats-new": "Novedades",
};

export const navBar = {
  ...navBarLabels,
};
